import React, { Fragment } from 'react';
import { object } from 'prop-types';
import classNames from 'classnames/bind';

import { ImageTechDoc } from 'components/ImageTechDoc';
import ResponsiveImage from 'components/ResponsiveImage';
import { getManufacturesInfoData } from 'containers/ManufacturesInfoData';
import { withLabels } from 'containers/withLabels';

import styles from './ManufacturesInfo.module.scss';
const cx = classNames.bind(styles);

const ManufacturesInfo = ({ data, labels }) => {
  const brandInfo = data.data ? data.data.array[0] : [];

  return (
    <section className={cx('root')}>
      <h3 className={cx('title')}>{labels.productManufactureInfoTitle}</h3>

      <div className={cx('info')}>
        {brandInfo.logoDocId && (
          <ResponsiveImage className={cx('image')}>
            <ImageTechDoc id={brandInfo.logoDocId} alt={brandInfo.name} />
          </ResponsiveImage>
        )}

        <div className={cx('col')}>
          <h4 className={cx('info-item', 'bold')}>{brandInfo.name}</h4>
          <h4 className={cx('info-item', 'bold')}>{brandInfo.name2}</h4>
          <p className={cx('info-item')}>{brandInfo.street}</p>
          <p className={cx('info-item')}>{brandInfo.street2}</p>
          <p className={cx('info-item')}>
            {brandInfo.zip} {brandInfo.city}
            {brandInfo.zipCountryCode && (
              <Fragment>{' (' + brandInfo.zipCountryCode + ')'}</Fragment>
            )}
          </p>
        </div>
        <div className={cx('col', 'col2')}>
          <p className={cx('info-item')}>
            <span className={cx('item-title')}>Fax</span>
            <span className={cx('item-text')}>{brandInfo.fax}</span>
          </p>
          <p className={cx('info-item')}>
            <span className={cx('item-title')}>Tel.</span>
            <span className={cx('item-text')}>{brandInfo.phone}</span>
          </p>
          {brandInfo.email && (
            <p className={cx('info-item')}>
              <span className={cx('item-title')}>&nbsp;</span>
              <a href={'mailto:' + brandInfo.email} className={cx('item-text')}>
                {brandInfo.email}
              </a>
            </p>
          )}
          {brandInfo.wwwURL && (
            <p className={cx('info-item')}>
              <span className={cx('item-title')}>&nbsp;</span>
              <a
                href={'https:' + brandInfo.wwwURL}
                className={cx('item-text')}
                target="_blank"
                rel="noopener noreferrer"
              >
                {brandInfo.wwwURL}
              </a>
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

ManufacturesInfo.propTypes = {
  data: object.isRequired,
  labels: object.isRequired,
};

export default getManufacturesInfoData(withLabels(ManufacturesInfo));



// WEBPACK FOOTER //
// ./src/pages/Product/components/ManufacturesInfo/ManufacturesInfo.js